import isEmpty from 'lodash/isEmpty';
import { generatePath } from 'react-router';
import store from '@Store';
import get from 'lodash/get';
import cleanUp from '@Services/Auth/AuthCleanUp';
import * as AuthHelper from '@Services/Auth/AuthHelper';
import RxSocket from '@Services/RxSocket';
import { loginTypes } from '@Constants/CommonConstants';
import { projectsClearStateAction } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { clearRsSavedLocation } from '@Pages/RetroSynthesis/RetroSynthesisRoot/utils/rsSavedLocation';
import AppStorage from '@Services/AppStorage';
import AccountData from '@Services/AccountData';
import NavigationHistory from '@Services/NavigationHistory';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import { replaceLocation, getLocationOrigin } from '@Utils/navigation';

export default class Login {
  static cancelLogin() {
    const lastState = NavigationHistory.getLastVisitedStateForLogin();

    if (lastState) {
      history.push({
        pathname: lastState.pathName,
        state: lastState.params,
      });
    } else {
      AuthHelper.goToLandingPage();
    }
  }

  static checkPermissions(ignoreRedirect) {
    if (AuthHelper.isReaxysAllowed()) {
      if (!ignoreRedirect) {
        AuthHelper.goToLandingPage();
      }
      AppStorage.instance.set('loginType', loginTypes.SIMPLE);
      return;
    }

    if (AppStorage.instance.get('shibbolethInfo')) {
      history.push({
        pathname: generatePath(paths.PRIVATE_REGISTER),
      });
      return;
    }

    history.push({
      pathname: generatePath(paths.LOGIN),
    });
  }

  static afterLogout(isRemoveRemember) {
    // RS - clean-up on logout
    store.dispatch(projectsClearStateAction());

    cleanUp();
    RxSocket.disconnect();

    // remove 'remember me' cookie
    if (isRemoveRemember) {
      AuthHelper.setRememberMeToken();
      AppStorage.instance.remove('userInstitutionInfo');
    }
    return Promise.resolve(true);
  }

  static afterAuthRedirect() {
    // set visitor.loginSuccess
    AccountData.updateExtendedData({
      loginSuccess: 'true',
    });

    // RS - clean-up on login
    store.dispatch(projectsClearStateAction());
    clearRsSavedLocation();

    const originalPath = get(AuthHelper.getUser(), 'target');
    const hopintoPath = AppStorage.instance.get('hopintoPath');
    const postLoginRedirect = AppStorage.instance.get('postLoginRedirect');
    const scheduledAlert = AppStorage.instance.get('scheduledAlert');
    const scheduledHistory = AppStorage.instance.get('scheduledHistory');
    const revisitLastState = AppStorage.instance.get('revisitLastState'); // if should just go back to previous state

    if (!AuthHelper.isReaxysAllowed()) {
      Login.checkPermissions();
      return;
    }

    if (originalPath) {
      AppStorage.instance.set('loginType', loginTypes.INSTITUTION);
      const path = getLocationOrigin().indexOf('/#') >= 0 ? originalPath : `#${originalPath}`;
      replaceLocation(path);
      return;
    }

    if (hopintoPath) {
      AppStorage.instance.set('hopintoPath', null);
      const path = getLocationOrigin().indexOf('/#') >= 0 ? hopintoPath : `#${hopintoPath}`;
      replaceLocation(path);
      return;
    }

    if (postLoginRedirect?.pathname) {
      AppStorage.instance.set('postLoginRedirect', null);
      history.push({
        pathname: postLoginRedirect.pathname,
        state: postLoginRedirect.state,
      });
      return;
    }

    if (scheduledAlert || scheduledHistory || revisitLastState) {
      const state = NavigationHistory.getLastVisitedStateForLogin();

      // Clear revisit last state flag
      if (revisitLastState) {
        AppStorage.instance.set('revisitLastState', null);
      }

      if (!isEmpty(state)) {
        history.push({
          pathname: state.pathName,
          state: state.params,
        });
      } else {
        AuthHelper.goToLandingPage();
      }
      return;
    }

    // fallback - landing page
    AuthHelper.goToLandingPage();
  }
}
